import { useState } from 'react'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage, $userToken } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import Break from '@/shared/ui/break'
import { Icon } from '@/shared/ui/icon'
import WebApp from '@twa-dev/sdk'
import ButtonWrapper from '@/shared/ui/buttonWrapper'
import { AppButton } from '@/shared/ui/button'
import { getAppStatusFx } from '@/entities/integration/model/effects'
import { goToMain } from '@/app/routing/events'
import { useHideNav } from '@/shared/hooks/useHideNav'

export const GamedUpdating = () => {
  const { classes } = useStyles()
  useHideNav()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.gamedUpdating
  const btnTexts = lang[userLang].pages.btnTexts
  const [isFetching, setIsFetching] = useState(false)
  const userToken = useUnit($userToken)
  const checkAppStatus = async () => {
    setIsFetching(true)
    const isWorking = await getAppStatusFx(userToken!)
    if (isWorking) {
      return goToMain()
    }
    setIsFetching(false)
  }

  return (
    <div className={classes.root}>
      <div className={classes.textWrapper}>
        <Icon
          view="gamedUpdating"
          width={54}
        />
        <span className={classes.heading}>{texts.heading}</span>
        <span className={classes.description}>{texts.description}</span>
        <Break width="90%" />
        <span className={classes.notation}>
          {texts.notation(
            () => WebApp.openTelegramLink(''),
            () => WebApp.openTelegramLink('')
          )}
        </span>
      </div>
      <ButtonWrapper>
        <AppButton
          className={classes.button}
          disabled={isFetching}
          onClick={checkAppStatus}
        >
          <Icon
            view="updating"
            style={{ animation: isFetching ? 'testing 1s linear infinite' : '' }}
          />
          <span className={classes.btnText}>{btnTexts.updatePage}</span>
        </AppButton>
      </ButtonWrapper>
    </div>
  )
}
